<template>
    <!-- <svg :x="box.x" :y="box.y" :width="box.width" :height="box.height">
        <rect :x="0" :y="0" :width="box.width" :height="box.height" fill="transparent" stroke="grey" stroke-width="0.5"></rect>
        <text :x="(0 + box.width)/2" :y="(0 + box.height)/2" text-anchor="middle" contenteditable>Hello</text>
    </svg> -->
    <div class="text-field center d-flexx align-centerr pa-2" :style="textStyle">
        <!-- <span style="width: 100%;" contenteditable class="contenteditable">{{ box.properties.text }}</span> -->
        <span
            contenteditable
            class="contenteditable"
            style="text-wrap: wrap; word-wrap: break-word; hyphens: none; max-width: 100%"
            >{{ initialTextContent }}</span
        >
        <!-- <textarea type="text" v-model="box.properties.text"></textarea> -->
    </div>
</template>
<script lang="ts">
import { Box, Layout, TextFieldBox } from "../models";
import BoxPopupMenu from "../BoxPopupMenu.vue";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        BoxPopupMenu,
    },
})
export class TextField extends Vue {
    @Prop() box: TextFieldBox;

    initialTextContent: string = "";
    contentNode: HTMLElement;
    observer: MutationObserver;

    beforeMount() {
        this.initialTextContent = this.box.properties.text;
        const boxId = this.box.id;
        this.contentNode = document.querySelector(
            "#" + boxId + " .contenteditable[contenteditable]",
        );
        this.initObserver();
    }

    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    @Watch("box.properties.text")
    watch_text() {
        console.log("box.properties.text", this.box.properties.text);
    }

    get textStyle() {
        if (!this.box.selectedTextStyle) return this.box.selectedTextStyle;
        const objCopy = { ...this.box.selectedTextStyle };
        if (objCopy.italic === true) {
            objCopy.fontStyle = "italic";
        }
        objCopy.fontSize = objCopy.fontSize + "pt";
        objCopy.fontWeight = objCopy.bold ? "bold" : null;
        return objCopy;
    }

    observeMutations(mutations: MutationRecord[]) {
        mutations.forEach((mutation) => {
            console.log("input changed mutation", mutation, this.contentNode.innerText);
            console.log("getNormalizedContent", this.getNormalizedContent(this.contentNode));
            this.box.properties.text = this.getNormalizedContent(this.contentNode); //this.contentNode.innerText //this.contentNode.textContent
        });
    }

    initObserver() {
        // let element = document.querySelector('.contenteditable[contenteditable]')
        console.log("Initing observer", this.contentNode);
        this.observer = new MutationObserver(this.observeMutations);
        this.observer.observe(this.contentNode, {
            childList: true,
            characterData: true,
            subtree: true,
        });
    }

    decodeHTMLEntities(html: string): string {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    getNormalizedContent(editableDiv: HTMLElement): string {
        // if (!editableDiv)
        let content = editableDiv.innerHTML;

        // Replace <div>, <p>, or similar tags with new lines
        content = content.replace(/<\/?(div|p)[^>]*>/gi, "\n");

        // Replace <br> tags with new lines
        content = content.replace(/<br\s*[\/]?>/gi, "\n");

        // Decode HTML entities (like &nbsp;)
        content = this.decodeHTMLEntities(content);

        // Remove any other HTML tags (optional)
        // content = content.replace(/<\/?[^>]+(>|$)/g, "");

        return content;
    }
}

export default toNative(TextField);
</script>
<style lang="css" scoped>
.text-field {
    height: 100%;
    width: 100%;
}

.contenteditable {
    cursor: default;
    /* background: red !important; */
}

textarea:focus {
    width: 100%;
}

[contenteditable] {
    outline: 0px solid transparent;
}

/* .text-field.center, .text-field.middle, .text-field.text-center, .text-field.text-middle {
    text-align: center;
}

.text-field.start, .text-field.text-start {
    text-align: start;
}

.text-field.end, .text-field.text-end {
    text-align: end;
} */
</style>
